// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- RxJs
import { BehaviorSubject, Observable } from 'rxjs';

// #endregion

@Injectable({
  providedIn: 'root'
})
export abstract class CommunicationsBaseService {
  protected _showSurveyNotifications$: BehaviorSubject<boolean>;
  get showSurveyNotifications$(): Observable<boolean> {
    return this._showSurveyNotifications$.asObservable();
  }

  protected _showUpdatesInspirationOffers$: BehaviorSubject<boolean>;
  get showUpdatesInspirationOffers$(): Observable<boolean> {
    return this._showUpdatesInspirationOffers$.asObservable();
  }

  constructor() {
    this._showSurveyNotifications$ = new BehaviorSubject<boolean>(null);
    this._showUpdatesInspirationOffers$ = new BehaviorSubject<boolean>(null);
  }

  abstract loadUserCommunicationPreferences(): void;
  abstract setShowUpdates(value: boolean): void;
  abstract setShowSurveyNotifications(value: boolean): void;
}
